import { useCallback } from 'react';
import { ONBOARDING_LITE_STEPS, useOnboardingStage } from '#shared/api/onboarding';
import { showError } from '#shared/lib/toast';
import { type VariantPublishButtonProps } from '../OnboardingStepsRenderer';
import { PublishButton } from '../PublishButton';
import { showLitePublishSuccessModal } from './LitePublishSuccessModal';

export function LitePublishButton({ name, isDisabled, 'data-testid': dataTestId }: VariantPublishButtonProps) {
    const { complete, isLoading } = useOnboardingStage(ONBOARDING_LITE_STEPS.PUBLISH);

    const handleClick = useCallback(async () => {
        try {
            await complete();
            showLitePublishSuccessModal();
        } catch (error) {
            showError({ label: 'Не удалось опубликовать магазин' }, error);
        }
    }, [complete]);

    return (
        <PublishButton
            data-testid={dataTestId}
            name={name}
            isDisabled={isDisabled}
            isLoading={isLoading}
            onClick={handleClick}
            tooltip="Чтобы опубликовать товары для продажи — закройте все предыдущие шаги"
        />
    );
}
